import dayjs from 'dayjs'
import 'dayjs/locale/ru'

dayjs.locale('ru')

export const getDateFormat = (date: string, format: string = "DD MMM YYYY, HH:mm") => {
  return dayjs(date).format(format)
}